'use client';

import { useState } from 'react';

import { useReviewEligibility } from '@/services/query/review.queries';
import { ReviewPromptModal } from './ReviewPromptModal';

/**
 * Self-contained gate that surfaces the MANDATORY experience-review prompt.
 * Mounted globally so it can fire on any page once the user hits their 2nd trade
 * or 2nd deposit. The prompt can only be closed by submitting a review — there
 * is no dismiss path — so this simply opens the modal whenever the user is
 * eligible and closes it once the review has been recorded.
 */
export const ReviewPromptGate = () => {
  // Once submitted in this session, never re-open (guards the brief window
  // before the eligibility query refetches to eligible=false).
  const [completed, setCompleted] = useState(false);
  const { data } = useReviewEligibility();

  // Derived during render rather than mirrored into state from an effect:
  // visibility is a pure function of eligibility plus the session guard, so
  // there is nothing to synchronise and no cascading render to pay for.
  const open = !completed && Boolean(data?.eligible) && !data?.hasReviewed;

  if (!open) return null;

  return (
    <ReviewPromptModal
      open={open}
      onSubmitted={() => setCompleted(true)}
      trigger={data?.reason ?? 'manual'}
    />
  );
};
